import { Constants as FrameworkConstants } from "@seriously-rad/seriouslyrad-framework-core/Constants";
export class Constants
{
    // #region General

    public static readonly CASE_REFERRAL_CANCELLATION_PROCESS_MESSAGE_TYPE_ID = "BDD6DE7C-0590-4DAF-94EC-2C7527E00907";
    public static readonly ENQUIRY_TELEPHONE_CALL_TIMESLOT_LIST = [
        { description: "9AM - 11AM", value: 1 << 0 },
        { description: "11AM - 1PM", value: 1 << 1 },
        { description: "1PM - 3PM", value: 1 << 2 },
        { description: "3PM - 5PM", value: 1 << 3 },
    ];
    public static readonly MEF_ERRORS_IN_REFERRAL_SUMMARY_OR_NOTICE_OF_ARRANGEMENT_LIST = [
        { description: "Incorrect contact details", value: 1 << 0 },
        { description: "Incorrect school name", value: 1 << 1 },
        { description: "Incorrect reason for referral", value: 1 << 2 },
        { description: "Incorrect primary SEND of CYP", value: 1 << 3 },
        { description: "Incomplete list of attendees", value: 1 << 4 },
    ];
    public static readonly MEF_HEALTH_AND_SOCIAL_CARE_LIST = [
        { description: "Health (other than SEMH)", value: 1 << 0 },
        { description: "Social Care", value: 1 << 1 },
        { description: "N/A", value: 1 << 2 },
    ];
    public static readonly MEF_EHCP_SECTIONS_IN_DISPUTE_LIST = [
        { description: "A The views, interests and aspirations of the child and their parents or of the young person", value: 1 << 0 },
        { description: "B The child or young person’s SEN", value: 1 << 1 },
        { description: "C The child or young person’s health care needs which relate to their SEN", value: 1 << 2 },
        { description: "D The child or young person’s social care needs which relate to their SEN or to a disability", value: 1 << 3 },
        { description: "E The outcomes sought for the child or young person (including outcomes for life)", value: 1 << 4 },
        { description: "F The Special Educational provision required by the child or young person", value: 1 << 5 },
        { description: "G Any health provision reasonably required by the learning difficulties or disabilities which result in the child / YP having SEN", value: 1 << 6 },
        { description: "H1 Any social care provision which must be made for a child / YP under 18 resulting from s.2 Chronically Sick &Disabled Persons Act 1970 (CSDPA)", value: 1 << 7 },
        { description: "H2 Any other social care provision reasonably required by the learning difficulties or disabilities which result in the child / young person having SEN", value: 1 << 8 },
        { description: "I Placement", value: 1 << 9 },
        { description: "J Personal Budget", value: 1 << 10 },
        { description: "K Advice & Information", value: 1 << 11 },
    ];
    public static readonly MEF_EHCP_SECTIONS_IN_DISPUTE_LIST_SUPPORTED = [
        { description: "A The views, interests and aspirations of the child and their parents or of the young person", value: 1 << 0 },
        { description: "B The child or young person’s Special Educational Needs", value: 1 << 1 },
        { description: "C The child or young person’s health care needs which relate to their SEN", value: 1 << 2 },
        { description: "D The child or young person’s social care needs which relate to their SEN or to a disability", value: 1 << 3 },
        { description: "E The outcomes sought for the child or young person (including outcomes for life)", value: 1 << 4 },
        { description: "F The Special Educational provision required by the child or young person", value: 1 << 5 },
        { description: "G Any health provision reasonably required by the learning difficulties or disabilities which result in the child / YP having SEN", value: 1 << 6 },
        { description: "H1 Any social care provision which must be made for a child / YP under 18 resulting from s.2 Chronically Sick &Disabled Persons Act 1970 (CSDPA)", value: 1 << 7 },
        { description: "H2 Any other social care provision reasonably required by the learning difficulties or disabilities which result in the child / young person having SEN", value: 1 << 8 },
        { description: "I Placement", value: 1 << 9 },
    ];
    public static readonly MEF_MEETING_ATTENDEES_LIST = [
        { description: "One parent / carer", value: 1 << 0 },
        { description: "Two parents / carers", value: 1 << 1 },
        { description: "One LA officer (SEN)", value: 1 << 2 },
        { description: "Two LA officers (SEN)", value: 1 << 3 },
        { description: "Representative from school", value: 1 << 7 },
        { description: "Two or more school representatives", value: 1 << 8 },
        { description: "Representative from Health", value: 1 << 4 },
        { description: "Representative from Social Care", value: 1 << 5 },
        { description: "Child /Young Person", value: 1 << 6 },
        { description: "Parental supporter (professional)", value: 1 << 9 },
        { description: "Parental supporter (non-professional)", value: 1 << 10 },
        { description: "Legal representative parent", value: 1 << 11 },
        { description: "Legal Representative LA", value: 1 << 12 },
        { description: "Professional Translator", value: 1 << 13 },
        { description: "Local authority observer", value: 1 << 14 },
        { description: "Mediator observer", value: 1 << 15 },
        { description: "Other", value: 1 << 16 },
    ];
    public static readonly TRACK_DISAGREEMENT_RESOLUTION = 1;
    public static readonly TRACK_MEDIATION = 1 << 1;
    public static readonly TRACK_LIST = [
        { description: "Disagreement Resolution", value: Constants.TRACK_DISAGREEMENT_RESOLUTION },
        { description: "Mediation", value: Constants.TRACK_MEDIATION }
    ];

    // #endregion

    public static readonly TeamNames = class
    {
        public static readonly ADMINISTRATION_SYSTEM_USERS = FrameworkConstants.TeamNames.ADMINISTRATION_SYSTEM_USERS;
        public static readonly ADMINISTRATORS = "Administrators";
        public static readonly ANGEL_FULFILMENT_SOLUTIONS_API = "Angel Fulfilment Solutions API";
        public static readonly APIS = "Apis";
        public static readonly CASE_MANAGERS = "Case Managers";
        public static readonly CUSTOMER_PORTAL_USERS = "Customer Portal Users";
        public static readonly INVOICE_ADMINISTRATOR = "Invoice Administrator";
        public static readonly LOCAL_AUTHORITY_STAFF = "Local Authority Staff";
        public static readonly MEDIATORS = "Mediators";
        public static readonly PARENTS = "Parents";
        public static readonly SENIOR_MANAGEMENT = "Senior Management";
        public static readonly SYSTEM_ADMINISTRATORS = FrameworkConstants.TeamNames.SYSTEM_ADMINISTRATORS;
    }
}
